import { Sector } from '@/domain/impact/impact.entity';
import {
  Category,
  ImpactCo2Answer,
  RecyclableWasteType,
  RecyclableWasteTypeValues,
  ValuesRecyclableWaste,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { ImportedRow } from '../convert-excel-to-impact-answers';
import { buildBaseAnswer } from './common/build-base-answer';
import {
  filterRowsByCategory,
  filterRowsBySectors,
} from './common/filter-rows-by-category';
import { ImportMappingError } from './common/import-mapping.error';

const CATEGORY: Category = 'RECYCLABLE_WASTE';
const SECTORS: Sector[] = ['SITE'];

export function mapToRecyclableWasteAnswers(
  rows: ImportedRow[],
): ImpactCo2Answer<ValuesRecyclableWaste>[] {
  return rows
    .filter(filterRowsByCategory(CATEGORY))
    .filter(filterRowsBySectors(SECTORS))
    .map((row) => buildAnswer(row));
}

function buildAnswer(row: ImportedRow) {
  const recyclableWasteType = mapToRecyclableWasteType(row);
  const recyclableWasteQuantity = mapToRecyclableWasteQuantity(row);
  const baseAnswer = buildBaseAnswer(row, CATEGORY);
  const answer = {
    ...baseAnswer,
    values: {
      ...baseAnswer.values,
      recyclableWasteType,
      recyclableWasteQuantity,
    },
  };
  return answer;
}

function mapToRecyclableWasteType(row: ImportedRow): RecyclableWasteType {
  const tgsValue = row['Fairly Sub Category Description'];
  const result = validateValueInType<RecyclableWasteType>(
    tgsValue,
    RecyclableWasteTypeValues,
  );
  if (!result) {
    throw new ImportMappingError('recyclableWasteType', tgsValue, row);
  }
  return result;
}

function mapToRecyclableWasteQuantity(row: ImportedRow): number {
  const tgsValue = row['Weight (kg)'];
  let result = parseFloat(tgsValue);
  if (isNaN(result)) {
    throw new ImportMappingError('recyclableWasteQuantity', tgsValue, row);
  }
  result = result / 1000; // convert kg to tonnes
  return result;
}
